<template>
  <QuestionBase :disabled-valid="false"
                :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="!!data">
    <InputBasic v-model="data"
                :args="args"
                :db="db"
                :noSave="noSave"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'Balance',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: [
        Number,
        String
      ],
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: false
    },
    propertyFound: {
      type: String
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    question() {
      return {
        title: `${this.type === 'Remortgage' ? 'How much would you like to borrow on the new mortgage?' : this.propertyFound === 'To Negotiate' ? 'How much are you likely to borrow on a mortgage?' : this.propertyFound === 'Still Looking' ? 'How much would you like to borrow on a mortgage?' : 'How much are you planning to borrow on a mortgage?'}`,
        subTitle: null,
        tip: null,
      }
    },
  },
  data() {
    return {
      db: {
        saveLocation: 'mortgage_survey_save',
        saveField: 'new_balance',
        objectId: this.objectId
      },
      args: {
        placeholder: 'e.g. 150,000',
        label: null,
        type: 'number',
        skippable: true,
        required: true,
        inputClass: 'field-66',
        prependText: '£'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>